import { Badge } from "@mui/material";
import type { FC } from "react";

export const NavbarBadge: FC<{ badgeContent: React.ReactNode }> = ({ badgeContent }) => {
  return (
    <Badge
      color="secondary"
      badgeContent={badgeContent}
      overlap="circular"
      sx={{
        display: "inline",
        "& .MuiBadge-badge": {
          transform: "unset",
          position: "unset",
        },
      }}
    />
  );
};
